var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('has-universe',{attrs:{"universe":_vm.universe,"toggle":""}},[_c('v-btn',{staticClass:"px-6",attrs:{"to":("/ui/universe/" + _vm.universe + "/settings"),"text":"","large":"","color":"deep-purple"}},[_vm._v(" Details ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }